// extracted by mini-css-extract-plugin
export default {"link":"SectionItem_link__bgMbh","sectionMenuButton":"SectionItem_sectionMenuButton__MrJlX","activeSection":"SectionItem_activeSection__ZwzID"};